import React, {useEffect} from 'react';
import {logCaseVisit} from "../../services/api";

const Crime = () => {
  useEffect(() => {
  logCaseVisit('CRIME').catch((error) => {
    console.error('Не удалось залогировать посещение кейса CRIME', error);
  });
}, []);
  return (
    <iframe
      src="https://iframe.digitalatyrau.kz/crime"
      title="crime"
      style={{ border: 'none' }}
      width="100%"
      height="100%"
    />
  );
};

export default Crime;
